import React from 'react';

/**
 * Icône Maintenance & Support - Clé et engrenage
 */
const Maintenance = ({
  size = 48,
  className = '',
  animate = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-maintenance ${animate ? 'icon-animate' : ''} ${className}`}
    >
      <defs>
        <linearGradient id="maintenanceGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#34d399" />
        </linearGradient>
      </defs>

      {/* Engrenage */}
      <g transform="translate(28, 14)">
        <circle
          cx="0"
          cy="0"
          r="8"
          stroke="url(#maintenanceGrad)"
          strokeWidth="2.5"
          fill="url(#maintenanceGrad)"
          fillOpacity="0.15"
        />
        {/* Dents de l'engrenage */}
        <circle cx="0" cy="-8" r="1.5" fill="white" />
        <circle cx="6" cy="-5" r="1.5" fill="white" />
        <circle cx="6" cy="5" r="1.5" fill="white" />
        <circle cx="0" cy="8" r="1.5" fill="white" />
        <circle cx="-6" cy="5" r="1.5" fill="white" />
        <circle cx="-6" cy="-5" r="1.5" fill="white" />
        {/* Centre */}
        <circle cx="0" cy="0" r="3" fill="white" />
      </g>

      {/* Clé (wrench) */}
      <g>
        <path
          d="M18 30 L18 34 L14 34 L14 30 L18 30 Z"
          stroke="url(#maintenanceGrad)"
          strokeWidth="2.5"
          fill="url(#maintenanceGrad)"
          fillOpacity="0.15"
        />
        <line
          x1="16"
          y1="30"
          x2="16"
          y2="18"
          stroke="url(#maintenanceGrad)"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <circle
          cx="16"
          cy="18"
          r="3"
          stroke="url(#maintenanceGrad)"
          strokeWidth="2.5"
          fill="url(#maintenanceGrad)"
          fillOpacity="0.15"
        />
      </g>

      {/* Étincelles/étoiles (travail en cours) */}
      <g opacity="0.7">
        <path d="M10 12 L11 14 L10 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 14 L10 14 L12 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export default Maintenance;
